// AI Generated Component
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { PageRepoService } from '@client/app/services/api/page-repo/page-repo.service';

@Component({
    selector: 'page-details-section-seo',
    standalone: false,
    template: `
        <div id="page-details-seo">
            <div class="row page-details-section-header">
                <div class="col-48">
                    <page-header icon="fas fa-chart-line" [header]="'Search Engine Optimization (SEO)' | translate"
                                 subHeader="">
                        <page-header-content>
                            <div class="row">
                                <div class="col-48 text-right">
                                    <table-compliance
                                            class="inline-block inner-r-small outer-small-minus"
                                            *ngIf="pageSeoIssues"
                                            [data]="[pageSeoIssues.length - pageSeoIssuesNotInComplianceCount, pageSeoIssuesNotInComplianceCount]"
                                            [labels]="['', '']"
                                            size="46"
                                            [btnWord]="'Overall SEO compliance for this page' | translate"
                                            [indexNumber]="0">
                                    </table-compliance>
                                </div>
                            </div>
                        </page-header-content>
                    </page-header>
                </div>
            </div>
            <div class="row page-details-section-body align-items-stretch">
                <div class="col-lg-30 pr-lg-0">
                    <div class="scroll max-height">
                        <page-details-seo-table
                                (onChangePageSeoIssue)="setPageSeoIssue($event.pageSeoIssue)"
                                [progress]="progress"
                                [pageSeoIssues]="pageSeoIssues"
                                [selectedSeoIssue]="pageSeoIssue">
                        </page-details-seo-table>
                    </div>
                </div>
                <div class="col-lg-18 pl-lg-0 information-shadow bg-light-grey">
                    <div class="scroll max-height">
                        <page-details-seo-information
                                (getPageSeoIssues)="refreshPageSeoIssues($event.refreshPage)"
                                [page]="page"
                                [selectedSeoIssue]="pageSeoIssue">
                        </page-details-seo-information>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class PageDetailsSectionSeoComponent implements OnInit {
    @Input() page: any;
    @Output() refreshPage = new EventEmitter<any>();
    @Input() active: any;

    pageSeoIssue: any;
    pageSeoIssues: any[] = [];
    pageSeoIssuesNotInComplianceCount = 0;
    progress: any;

    constructor (
        private pageRepoService: PageRepoService,
    ) {}

    ngOnInit (): void {
        this.page = this.page || {};
        if (this.active !== null && typeof this.active === 'object' && !Array.isArray(this.active)) {
            this.pageSeoIssue = this.active;
            if (!this.pageSeoIssue.translation_name) {
                this.pageSeoIssue.translation_name = this.active.name;
            }
        } else {
            this.pageSeoIssue = null;
        }
        this.pageSeoIssues = [];
        this.refreshPageSeoIssues();
    }

    refreshPageSeoIssues (refreshPage?: boolean): void {
        this.progress = this.getPageSeoIssues().then((seoIssues: any) => {
            this.pageSeoIssues = this.sortPageSeoIssues(seoIssues);

            if (typeof this.pageSeoIssue === 'object' && this.pageSeoIssue !== null) {
                this.pageSeoIssue = this.pageSeoIssues.find((issue: any) => {
                    return issue.translation_name === this.pageSeoIssue.translation_name;
                });
            } else {
                this.pageSeoIssue = this.pageSeoIssues[0];
            }
            this.setPageSeoIssue(this.pageSeoIssue);
        }, () => {});

        if (typeof refreshPage === 'boolean' && refreshPage === true) {
            this.refreshPage.emit({ target: 'page-details-section-seo' });
        }
    }

    private getPageSeoIssues (): Promise<any> {
        const params = {
            page: 1,
            page_size: 10000,
        };

        return this.pageRepoService.getSeoIssues(this.page.id, params).then((data: any) => {
            this.pageSeoIssuesNotInComplianceCount = data.filter((issue: any) => {
                return issue.issues.length > 0;
            }).length;
            return data;
        }).catch((error: any) => {
            return Promise.reject(error);
        });
    }

    private sortPageSeoIssues (issues: any[]): any[] {
        return issues
            .map((issue: any) => {
                issue.ignored_on_page = this.isSeoCheckpointIsIgnored(issue);
                issue.fixed = this.checkIfAllAreFixed(issue);
                return issue;
            })
            .sort((a: any, b: any) => {
                if (a.ignored_on_page || b.ignored_on_page) {
                    // Order by ignored
                    if (a.ignored_on_page && !b.ignored_on_page) {
                        return 1;
                    } else if (b.ignored_on_page && !a.ignored_on_page) {
                        return -1;
                    }
                }

                if (b.fixed || a.fixed) {
                    // Order by fixed
                    if (a.fixed && !b.fixed) {
                        return 1;
                    } else if (b.fixed && !a.fixed) {
                        return -1;
                    }
                }

                // Order by classification
                return a.classification > b.classification ? 1 : a.classification < b.classification ? -1 : 0;
            });
    }

    private isSeoCheckpointIsIgnored (seoCheckpoint: any): boolean {
        if (seoCheckpoint.ignored) {
            return true;
        } else {
            const issues = seoCheckpoint.issues;
            if (issues.length > 0) {
                return issues[0].ignored_at !== null;
            }
        }

        return false;
    }

    private checkIfAllAreFixed (seoCheckpoint: any): boolean {
        if (seoCheckpoint.ignored) {
            return false;
        }

        if (seoCheckpoint.issues.length === 0) {
            return true;
        }

        const issue = seoCheckpoint.issues[0];
        return issue.marked_as_fixed_at !== null;
    }

    setPageSeoIssue (seoIssue: any): void {
        this.pageSeoIssue = seoIssue;
        if (typeof seoIssue === 'object' && seoIssue !== null && !seoIssue.ignored && !seoIssue.fixed) {
            this.pageRepoService.getSeoIssueContent(this.page.id, this.pageSeoIssue.issues[0].id).then((data: any) => {
                this.pageSeoIssue.content = data;
            }, () => {});
        }
    }
}
